import { OidcProvider } from '@axa-fr/react-oidc';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "./components/common";
import theme from "./theme";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "./components/Localization";
import { oidcConfiguration } from './oidcConfig';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <OidcProvider configuration={oidcConfiguration}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider>
            <App />
            <Toaster />
          </LocalizationProvider>
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </OidcProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
